<div class="ec-plants-container" fxLayout="column" fxLayoutGap="20px">
    <ng-container *appVar="hierarchyEntity|async as hierarchyEntity">
        <div class="mt-16" fxLayout="row" fxLayoutAlign="start center">
            <button app-ghost-button (click)="goBack()">
                <app-icon name="fal-arrow-left"></app-icon>
                {{ 'Back to Communities Total'|i18n }}
            </button>
        </div>
        <form [formGroup]="form">
            <div fxLayout="column" fxLayoutGap="12px" class="back-panel">
                <app-filter-bar
                        [config]="billingPeriodCfg"
                        [billingPeriod]="billingPeriod"
                        [useFilter]="USE_FILTER"
                        [showGSEBtn]="false"
                        (exportDataEventEmitter)="exportEconomicsToExcel()"
                        (billingPeriodEventEmitter)="onChangeBillingPeriod($event)">
                </app-filter-bar>
                <!-- estimated data label -->
                <div *ngIf="dataSourceInfo" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px"
                     class="txt-p-14-4 mt-32">
                    <app-icon [name]="dataSourceInfo.iconName"></app-icon>
                    <div>{{ dataSourceInfo.title|i18n }}</div>
                    <app-icon name="fas-info-circle" [title]="dataSourceInfo.iconTitle|i18n"></app-icon>
                    <app-icon *ngIf="missingCosts(response,this.strategy)" icon-color-w name="fas-exclamation-triangle"
                              [title]="'Configure expenses'|i18n">
                    </app-icon>
                </div>

                <!-- top tiles row -->
                <div *ngIf="response" fxLayout="row" fxLayoutAlign="start stretch" fxLayoutGap="12px"
                     class="recap-container">

                    <!-- net cacv -->
                    <div fxLayout="column" fxFlex="22" class="block" fxLayoutGap="12px">
                        <div fxLayout="row" fxLayoutAlign="space-between center">
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="18px">
                                <app-icon icon-color-s name="fal-piggy-bank"></app-icon>
                                <div class="txt-h-18-7 mr-30" [innerHTML]="'Net {0}'|i18n:CACV_STRING"></div>
                                <app-icon *ngIf="missingCacvMode(response, this.strategy)"
                                          [title]="'Configure the destination of CACV'|i18n" icon-color-w
                                          name="fas-exclamation-triangle">
                                </app-icon>
                            </div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-between center">
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="18px">
                                <div class="txt-h-26-7 mr-30">
                                    <ng-container *ngIf="missingCacvMode(response,this.strategy) ||
                                                         !isDefined(response.c_acv_mode) ||
                                                         !isDefined(response.net_c_acv)">
                                        {{ NULL_DATA }}
                                    </ng-container>
                                    <ng-container *ngIf="!missingCacvMode(response,this.strategy) &&
                                                         isDefined(response.c_acv_mode) &&
                                                         isDefined(response.net_c_acv)">
                                        {{ response.net_c_acv|niceValue:'€':2 : response.net_c_acv < 0 }}
                                    </ng-container>
                                </div>
                            </div>
                            <button class="pencil-button" app-small-primary-button *ngIf="enableFeatures(ECEconomicsFeatures.PLANT_CACV)"
                                    [disabled]="missingCosts(response,this.strategy) || onlyCommunityPlants"
                                    (click)="openConfigureDialog(DialogMode.CACV)">
                                <app-icon name="fal-pencil-alt" class="no-margin"></app-icon>
                            </button>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="txt-s-14-4">
                            <ng-container
                                    *ngIf="missingCosts(response,this.strategy) || !isDefined(response.c_acv_mode) || !isDefined(response.net_c_acv)">
                                <app-icon name="fal-arrow-right" icon-color-s></app-icon>
                                <div>{{ 'To be allocated'|i18n }}</div>
                            </ng-container>
                            <ng-container *ngIf="!missingCosts(response,this.strategy) && isDefined(response.c_acv_mode) &&
                                                 isDefined(response.net_c_acv)">
                                <app-icon
                                        *ngIf="(isDefined(response.net_c_acv) && response.c_acv_mode !== ECCacvRedistributionMode.SET_ASIDE)"
                                        name="fal-arrow-right" icon-color-s></app-icon>
                                <app-icon
                                        *ngIf="(isDefined(response.net_c_acv) && response.c_acv_mode === ECCacvRedistributionMode.PLANTS)"
                                        name="fal-solar-panel" icon-color-s></app-icon>
                                <app-icon
                                        *ngIf="(isDefined(response.net_c_acv) && response.c_acv_mode === ECCacvRedistributionMode.REDISTRIBUTION) || onlyCommunityPlants"
                                        name="fal-plug" icon-color-s></app-icon>
                                <app-icon
                                        *ngIf="(isDefined(response.net_c_acv) && response.c_acv_mode === ECCacvRedistributionMode.SET_ASIDE)"
                                        name="fal-times-circle" icon-color-s></app-icon>
                                <ng-container *ngIf="(isDefined(response.net_c_acv) && response.c_acv_mode === ECCacvRedistributionMode.AS_TIP)">
                                    <app-icon name="fal-plug" icon-color-s></app-icon>
                                    <app-icon name="fal-solar-panel" icon-color-s></app-icon>
                                </ng-container>
                                <div>{{ (onlyCommunityPlants ? ECCacvRedistributionMode.REDISTRIBUTION : response.c_acv_mode)|cacvMode|i18n }}</div>
                            </ng-container>
                        </div>
                    </div>

                    <!-- net tip -->
                    <div fxLayout="column" fxFlex="50" class="block" fxLayoutGap="20px">
                        <div fxLayout="column" fxLayoutGap="12px">
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="18px">
                                <app-icon icon-color-s name="fal-piggy-bank"></app-icon>
                                <div class="txt-h-18-7 mr-30">{{ 'Net TIP'|i18n }}</div>
                                <app-icon *ngIf="missingTipQuote(response, this.strategy)"
                                          [title]="'Configure TIP quote withheld by plants'|i18n"
                                          icon-color-w name="fas-exclamation-triangle">
                                </app-icon>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between center">
                                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="18px">
                                    <div class="txt-h-26-7 mr-30">
                                        <ng-container *ngIf="missingCosts(response,this.strategy) || !(isDefined(response.ec_plants_net_tip) &&
                                                         isDefined(response.member_plants_net_tip) &&
                                                         isDefined(response.third_party_plants_net_tip))">
                                            {{ NULL_DATA }}
                                        </ng-container>
                                        <ng-container *ngIf="!missingCosts(response,this.strategy) && isDefined(response.ec_plants_net_tip) &&
                                                         isDefined(response.member_plants_net_tip) &&
                                                         isDefined(response.third_party_plants_net_tip)">
                                            {{ getSum([response.ec_plants_net_tip, response.member_plants_net_tip, response.third_party_plants_net_tip])|niceValue:'€':2 : getSum([response.ec_plants_net_tip, response.member_plants_net_tip, response.third_party_plants_net_tip]) < 0 }}
                                        </ng-container>
                                    </div>
                                    <button class="pencil-button" app-small-primary-button *ngIf="enableFeatures(ECEconomicsFeatures.PLANT_TIP)"
                                            [disabled]="missingCosts(response,this.strategy) || hasNoMemberPlants && hasNoThirdPlants"
                                            (click)="openConfigureDialog(DialogMode.TIP)">
                                        <app-icon name="fal-pencil-alt" class="no-margin"></app-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-between center">
                            <div fxLayout="column" fxLayoutGap="12px" fxLayoutAlign="start center">
                                <span class="txt-h-12-7">{{ 'Community'|i18n }}</span>
                                <span class="txt-h-16-7">
                                    <ng-container
                                            *ngIf="missingCosts(response,this.strategy) || !isDefined(response.ec_plants_net_tip) || hasNoEcPlants">
                                        {{ NULL_DATA }}
                                    </ng-container>
                                    <ng-container
                                            *ngIf="!missingCosts(response,this.strategy) && isDefined(response.ec_plants_net_tip) && !hasNoEcPlants">
                                        {{ response.ec_plants_net_tip|niceValue:'€':2: response.ec_plants_net_tip < 0 }}
                                    </ng-container>
                                </span>
                            </div>
                            <div fxLayout="column" fxLayoutGap="12px" fxLayoutAlign="start center">
                                <span class="txt-h-12-7">{{ 'Members plants__{pv}'|i18n }}</span>
                                <span class="txt-h-16-7">
                                    <ng-container
                                            *ngIf="missingCosts(response,this.strategy) || !isDefined(response.member_plants_net_tip) || hasNoMemberPlants">
                                        {{ NULL_DATA }}
                                    </ng-container>
                                    <ng-container
                                            *ngIf="!missingCosts(response,this.strategy) && isDefined(response.member_plants_net_tip) && !hasNoMemberPlants">
                                        {{ response.member_plants_net_tip|niceValue:'€':2 : response.member_plants_net_tip < 0 }}
                                    </ng-container>
                                </span>
                            </div>
                            <div fxLayout="column" fxLayoutGap="12px" fxLayoutAlign="start center">
                                <span class="txt-h-12-7">{{ 'Third party plants'|i18n }}</span>
                                <span class="txt-h-16-7">
                                    <ng-container
                                            *ngIf="missingCosts(response,this.strategy) || !isDefined(response.third_party_plants_net_tip) || hasNoThirdPlants">
                                        {{ NULL_DATA }}
                                    </ng-container>
                                    <ng-container
                                            *ngIf="!missingCosts(response,this.strategy) && isDefined(response.third_party_plants_net_tip) && !hasNoThirdPlants">
                                        {{ response.third_party_plants_net_tip|niceValue:'€':2 : response.third_party_plants_net_tip < 0 }}
                                    </ng-container>
                                </span>
                            </div>
                        </div>
                    </div>

                    <!-- community plants withdrawal -->
                    <div fxLayout="column" fxFlex="26" class="block" fxLayoutGap="12px">
                        <div fxLayout="row" fxLayoutAlign="sart center" fxLayoutGap="18px">
                            <app-icon icon-color-s name="fal-solar-panel"></app-icon>
                            <div class="txt-h-18-7">{{ 'Community plants withdrawal'|i18n }}</div>
                            <app-icon icon-color-w name="fas-exclamation-triangle" class="mr-30"
                                      *ngIf="hasError(EconomicsErrorType.MISSING_ZONAL_PRICE, response.errors) && showError(EconomicsErrorType.MISSING_ZONAL_PRICE, response.errors)"
                                      [title]="'Due to partial zonal price supply, we cannot show you complete economic data for this period. No action is required on your part.'|i18n">
                            </app-icon>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-between center">
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="18px">
                                <div class="txt-h-26-7 mr-30">
                                    <ng-container *ngIf="!isDefined(response.ec_plants_rei) || hasNoEcPlants">
                                        {{ NULL_DATA }}
                                    </ng-container>
                                    <ng-container *ngIf="isDefined(response.ec_plants_rei) && !hasNoEcPlants">
                                        {{ response.ec_plants_rei|niceValue:'€':2: response.ec_plants_rei < 0 }}
                                    </ng-container>
                                </div>
                                <app-icon
                                        *ngIf="isDefined(response.ec_plants_rei) && !hasNoEcPlants && missingReiRedistribution(response,this.strategy)"
                                        [title]="'Configure plant quote from withdrawal'|i18n" class="mr-10"
                                        icon-color-w name="fas-exclamation-triangle">
                                </app-icon>
                                <app-icon *ngIf="hasNoEcPlants" [title]="'No active community plants found'|i18n"
                                          icon-color-h
                                          name="fas-info-circle">
                                </app-icon>
                            </div>
                            <button class="pencil-button" app-small-primary-button
                                    [disabled]="missingCosts(response,this.strategy) || hasNoEcPlants"
                                    (click)="openConfigureDialog(DialogMode.REI)">
                                <app-icon name="fal-pencil-alt" class="no-margin"></app-icon>
                            </button>
                        </div>
                        <div *ngIf="response.ec_plants_rei_redistribution_status"
                             fxLayout="column" fxLayoutGap="12px" class="mt-20">
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                <app-icon icon-color-s name="fal-piggy-bank"></app-icon>
                                <span class="txt-h-12-4" [ngSwitch]="response.ec_plants_rei_redistribution_status">
                                    <ng-container *ngSwitchCase="REIRedistributionStatus.REDISTRIBUTED">
                                        {{ 'Redistributable amount for members in absorption'|i18n }}:
                                    </ng-container>
                                    <ng-container *ngSwitchCase="REIRedistributionStatus.NOT_REDISTRIBUTED">
                                        {{ 'Amount not allocated for apportionment by withdrawing members'|i18n }}
                                    </ng-container>
                                    <ng-container *ngSwitchCase="REIRedistributionStatus.MIXED">
                                        {{ 'Share allocated for allocation by members in withdrawal'|i18n }}:
                                    </ng-container>
                                </span>
                            </div>
                            <div class="txt-h-16-7">
                                {{
                                    isDefined(response.redistributable_ec_plants_rei) ?
                                        (response.redistributable_ec_plants_rei|niceValue: '€': 2: response.redistributable_ec_plants_rei < 0) :
                                        NULL_DATA
                                }}
                            </div>
                        </div>
                    </div>

                    <!-- plants withdrawal -->
                    <div *ngIf="!isRepresentative" fxLayout="column" fxFlex="20" class="block" fxLayoutGap="10px">
                        <div fxLayout="row" fxLayoutAlign="space-between center">
                            <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start center">
                                <app-icon icon-color-s name="fal-piggy-bank"></app-icon>
                                <span class="txt-h-12-4">{{ 'Member plant withdrawal'|i18n }}</span>
                                <app-icon icon-color-w name="fas-exclamation-triangle" class="mr-30"
                                          *ngIf="hasError(EconomicsErrorType.MISSING_ZONAL_PRICE, response.errors) && showError(EconomicsErrorType.MISSING_ZONAL_PRICE, response.errors)"
                                          [title]="'Due to partial zonal price supply, we cannot show you complete economic data for this period. No action is required on your part.'|i18n">
                                </app-icon>
                            </div>
                            <span class="txt-h-16-7 mr-30">{{ isDefined(response.member_plants_rei) && !hasNoMemberPlants ? (response.member_plants_rei|niceValue:'€':2) : NULL_DATA }}</span>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-between center">
                            <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start center">
                                <app-icon icon-color-s name="fal-piggy-bank"></app-icon>
                                <span class="txt-h-12-4">{{ 'Thirds plant withdrawal'|i18n }}</span>
                                <app-icon icon-color-w name="fas-exclamation-triangle" class="mr-30"
                                          *ngIf="hasError(EconomicsErrorType.MISSING_ZONAL_PRICE, response.errors) && showError(EconomicsErrorType.MISSING_ZONAL_PRICE, response.errors)"
                                          [title]="'Due to partial zonal price supply, we cannot show you complete economic data for this period. No action is required on your part.'|i18n">
                                </app-icon>
                            </div>
                            <span class="txt-h-16-7 mr-30">{{ isDefined(response.third_party_plants_rei) && !hasNoThirdPlants ? (response.third_party_plants_rei|niceValue:'€':2) : NULL_DATA }}</span>
                        </div>
                    </div>
                </div>
                <!-- Economics warning banner -->
                <div *ngIf="response" fxLayoutAlign="center center">
                    <div *ngIf="plantsTipOverMaximum" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="18px"
                         economics-warning class="padding-12">
                        <app-icon icon-color-w name="fas-info-circle"></app-icon>
                        <div>{{ 'Maximum redistributable to companies exceeded by the plants redistributable. Reduce the TIP shares assigned to plants'|i18n }}</div>
                    </div>
                </div>
                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="start center" fxLayoutGap="24px"
                     class="mt-12">
                    <div app-input-container class="find-resource-container" fxFlex="none" fxLayout="row"
                         fxLayoutGap="24px">
                        <input app-input autocomplete="off"
                               class="find-resource txt-s-16-4"
                               [formControlName]="'searchText'"
                               [spellcheck]="false"
                               [placeholder]="'Search by plant or POD'|i18n">
                        <app-icon *ngIf="searchText && searchText.length > 0" name="fal-times"
                                  class="right-symbol clear"
                                  (click)="onClickClearSearchText()">
                        </app-icon>
                        <svg *ngIf="!searchText || searchText.length === 0" xmlns="http://www.w3.org/2000/svg"
                             viewBox="0 0 512 512"
                             class="right-symbol mag-glass">
                            <!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                            <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352c79.5 0 144-64.5 144-144s-64.5-144-144-144S64 128.5 64 208s64.5 144 144 144z"/>
                        </svg>
                    </div>
                    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="12px" fxLayoutAlign="start center"
                         class="plant-type-container">
                        <div fxFlex="35">{{ 'Filter by plant type'|i18n }}:</div>
                        <mat-select formControlName="plantType" app-small-select
                                    [placeholder]="allPlantsTypes[0].name|i18n">
                            <mat-option *ngFor="let type of allPlantsTypes" [value]="type.value">
                                {{ type.name|i18n }}
                            </mat-option>
                        </mat-select>
                    </div>
                </div>
                <div fxLayout="column" class="table-back mt-20" fxLayoutGap="20px">
                    <ng-container *appVar="plants|async as plants">
                        <ng-container *ngIf="isDetailViewable(hierarchyEntity); else unviewableEntity">
                            <ng-container *ngIf="plants; else loadingPlants">
                                <ng-container *ngIf="plants.total > 0">
                                    <table mat-table app-table [dataSource]="plants.pods"
                                           *appVar="expandedPlant|async as expandedPlant" multiTemplateDataRows
                                           class="plant-table">
                                        <ng-container matColumnDef="chevron">
                                            <td fxFlex="3" mat-cell *matCellDef="let row"
                                                class="cell first-cell" [ngClass]="{'expanded': row === expandedPlant}">
                                                <app-icon class="ml-12"
                                                          [name]="row === expandedPlant ? 'fal-chevron-down' : 'fal-chevron-right'">
                                                </app-icon>
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="name">
                                            <td fxFlex="20" mat-cell *matCellDef="let row" class="cell">
                                                <app-icon icon-color-h name="fal-network-wired" class="mr-10"
                                                          [hidden]="row.entity ? !row.entity.name : true"></app-icon>
                                                <span *ngIf="row.entity"
                                                      class="txt-h-16-5"> {{ row.entity.name }}</span>
                                                <span *ngIf="!row.entity" class="txt-h-16-5">-</span>
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="type">
                                            <td fxFlex="10" fxLayoutAlign="start center" mat-cell *matCellDef="let row"
                                                class="cell">
                                                <span class="txt-s-16-4">{{ setType(row)|genericPipe|i18n }}</span>
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="member">
                                            <td fxFlex="12" mat-cell *matCellDef="let row" class="cell">
                                                <ng-container *ngIf="row.member">
                                                    <app-icon icon-color-h name="fal-user" class="mr-10"></app-icon>
                                                    {{ row.member.personal_data.company_name || row.member.personal_data.first_name + ' ' + row.member.personal_data.last_name || '-' }}
                                                </ng-container>
                                                <ng-container *ngIf="isCommunityPlant(row)">
                                                    {{ 'Community'|i18n }}
                                                </ng-container>
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="pod">
                                            <td fxFlex="15" mat-cell class="cell" *matCellDef="let row">
                                                <span class="txt-s-14-4 mr-10">POD:</span>
                                                <span class="txt-s-14-4">{{ row.pod || '-' }}</span>
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="params">
                                            <td *matCellDef="let row" mat-cell fxLayoutAlign="start center"
                                                fxLayoutGap="30px"
                                                class="cell last-cell" fxFlex="40">
                                                <div *ngIf="row.generatesTip" class="monitored">
                                                    <app-icon name="fal-check-circle"></app-icon>
                                                    {{ 'Generates TIP'|i18n }}
                                                </div>
                                                <div *ngIf="!row.generatesTip" class="not-monitored">
                                                    <app-icon name="fal-times-circle"></app-icon>
                                                    {{ 'Doesn\'t generate TIP'|i18n }}
                                                </div>
                                                <div *ngIf="isCommunityPlant(row)" class="txt-s-14-4">
                                                    <app-icon *ngIf="!isDefined(row.rei_redistribution_status)"
                                                              icon-color-w name="fas-exclamation-triangle"
                                                              [title]="'Withdrawal destination not configured'|i18n">
                                                    </app-icon>
                                                    <div *ngIf="isDefined(row.rei_redistribution_status) && row.rei_redistribution_status"
                                                         class="monitored">
                                                        <app-icon name="fal-check-circle"></app-icon>
                                                        {{ 'Uses withdrawal by allocation'|i18n }}
                                                    </div>
                                                    <div *ngIf="isDefined(row.rei_redistribution_status) && !row.rei_redistribution_status"
                                                         class="not-monitored">
                                                        <app-icon name="fal-times-circle"></app-icon>
                                                        {{ 'Does not use withdrawal by allocation'|i18n }}
                                                    </div>
                                                </div>
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="expandedDetail">
                                            <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length">
                                                <div class="plant-details-container"
                                                     [@detailExpand]="row === expandedPlant ? 'expanded' : 'collapsed'"
                                                     fxLayout="column">
                                                    <div class="plant-details">
                                                        <app-ec-plants-details [economicsPlantsResponse]="response"
                                                                               [summaryConsolidations]="summaryResponse"
                                                                               [plantsPod]="row"
                                                                               [entity]="entity"
                                                                               [date]="singleDate"
                                                                               [timeZone]="timeZone"
                                                                               [minDate]="getMomentFromMs(getYear(billingPeriodCfg.pastDate), timeZone)"
                                                                               [maxDate]="getPastMonth(timeZone)"
                                                                               [isWholeYear]="isWholeYear"
                                                                               [isSingleMonth]="isSingleMonth"
                                                                               [selectedYear]="selectedYear"
                                                                               [enableTipConfig] = "enableFeatures(ECEconomicsFeatures.PLANT_TIP)"
                                                                               [strategy]="strategy"
                                                                               [isRepresentative]="isRepresentative"
                                                                               [generatesTip]="row.generatesTip"
                                                                               [economicsConfig]="economicsConfig"
                                                                               (detailsDataEvent)="onClickGseDataEntered()">
                                                        </app-ec-plants-details>
                                                    </div>
                                                </div>
                                            </td>
                                        </ng-container>
                                        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="app-row"
                                            [ngClass]="{'app-expanded-row': expandedPlant === row}"
                                            (click)="onSelectPlant(row)">
                                        </tr>
                                        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']"
                                            class="app-detail-row app-border-row"
                                            [ngClass]="{'app-expanded-row': expandedPlant === row}">
                                        </tr>
                                    </table>
                                </ng-container>
                                <div *ngIf="plants.total === 0" fxLayout="row" fxLayoutAlign="center" class="mt-20">
                                    {{ 'No plants found'|i18n }}
                                </div>
                            </ng-container>
                        </ng-container>
                        <mat-paginator #paginator app-paginator class="plant-paginator"
                                       [ngClass]="{'collapsed': !plants || !isDetailViewable(hierarchyEntity) || plants.total === 0}"
                                       [length]="plants?.total" [pageSize]="DEFAULT_PAGE_SIZE"
                                       [pageSizeOptions]="DEFAULT_PAGE_SIZES">
                        </mat-paginator>
                    </ng-container>
                </div>
            </div>
        </form>
    </ng-container>
</div>

<ng-template #loadingPlants>
    <div fxLayout="column" fxLayoutAlign="space-around center">
        <div fxLayout="row" fxLayoutAlign="center center" class="mt-24 mb-16">
            <mat-spinner app-spinner diameter="20"></mat-spinner>
            <span class="pl-8">{{ 'Loading plants'|i18n }}...</span>
        </div>
        <div *ngIf="showComputationWarning" fxLayout="row" fxLayoutAlign="center center"
             fxLayoutGap="30px" economics-warning class="mt-30 padding-14">
            <app-icon icon-color-w name="fas-info-circle"></app-icon>
            <div>{{ 'We are recalculating the economics data due to an updated configuration parameter.'|i18n }}</div>
        </div>
    </div>
</ng-template>

<ng-template #unviewableEntity>
    <div fxLayout="row" fxLayoutAlign="center" class="mt-16">
        {{ 'Insufficient permissions to view this resource'|i18n }}
    </div>
</ng-template>

<ng-template #configureCacvMode let-data let-close="close">
    <div class="dialog">
        <app-set-cacv [year]="selectedYear"
                      [currentCacvMode]="response.c_acv_mode"
                      (cacvYearlyValue)="data.cacvYearlyValue = $event"
                      (valid)="data.valid = $event">
        </app-set-cacv>
    </div>
    <div fxLayout="column" fxLayoutAlign="center center" class="mt-24">
        <div fxLayout="row" fxLayoutAlign="center start" fxLayoutGap="48px">
            <button app-ghost-button (click)="close(false)">
                {{ 'Cancel'|i18n }}
            </button>
            <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px">
                <button app-primary-button [disabled]="!data.valid || !data.cacvYearlyValue"
                        (click)="close(data.cacvYearlyValue)">
                    {{ 'Save changes'|i18n }}
                </button>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #configureTipQuote let-data let-close="close">
    <div class="dialog">
        <app-set-tip [year]="selectedYear"
                     [massiveConfig]="true"
                     [ECNE]="response.gse ? getSum([response.member_incentive_shared_energy_non_surplus,response.third_party_plants_incentive_shared_energy_non_surplus, response.ec_plants_incentive_shared_energy_non_surplus]) : getSum([response.member_estimated_incentive_shared_energy_non_surplus, response.third_party_plants_estimated_incentive_shared_energy_non_surplus, response.ec_plants_estimated_incentive_shared_energy_non_surplus])"
                     [incentiveSharedEnergy]="response.gse ? getSum([response.member_incentive_shared_energy, response.third_party_plants_incentive_shared_energy, response.ec_plants_incentive_shared_energy]) : getSum([response.member_estimated_incentive_shared_energy, response.third_party_plants_estimated_incentive_shared_energy, response.ec_plants_estimated_incentive_shared_energy])"
                     [grossTip]="getSum([response.member_plants_gross_tip, response.third_party_plants_gross_tip, response.ec_plants_gross_tip])"
                     [netTip]="getSum([response.member_plants_net_tip, response.third_party_plants_net_tip, response.ec_plants_net_tip])"
                     [nonSurplusTip]="getSum([response.member_plants_non_surplus_tip, response.third_party_plants_non_surplus_tip, response.ec_plants_non_surplus_tip])"
                     [capitalGrantUse]="false"
                     (tipResponse)="data.tipResponse = $event"
                     (valid)="data.valid = $event">
        </app-set-tip>
    </div>
    <div fxLayout="column" fxLayoutAlign="center center" class="mt-24">
        <div fxLayout="row" fxLayoutAlign="center start" fxLayoutGap="48px">
            <button app-ghost-button (click)="close(false)">
                {{ 'Cancel'|i18n }}
            </button>
            <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px">
                <button app-primary-button [disabled]="!data.valid || !data.tipResponse"
                        (click)="close(data.tipResponse)">
                    {{ 'Save changes'|i18n }}
                </button>
                <div fxLayout="row" fxLayoutAlign="center center">
                    <span class="txt-s-14-4">{{ 'Apply to all facilities'|i18n }}.</span>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #configureRei let-data let-close="close">
    <div class="rei-main-dialog">
        <app-set-rei [inputReiStatus]="response.ec_plants_rei_redistribution_status"
                     [year]="selectedYear"
                     [massiveConfig]="true"
                     (reiResponse)="data.reiResponse = $event"
                     (valid)="data.valid = $event">
        </app-set-rei>
    </div>
    <div fxLayout="column" fxLayoutAlign="center center" class="mt-24">
        <div fxLayout="row" fxLayoutAlign="center start" fxLayoutGap="48px">
            <button app-ghost-button (click)="close(undefined)">
                {{ 'Cancel'|i18n }}
            </button>
            <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px">
                <button app-primary-button [disabled]="!data.valid"
                        (click)="close(data.reiResponse)">
                    {{ 'Save changes'|i18n }}
                </button>
                <div fxLayout="row" fxLayoutAlign="center center">
                    <span class="txt-s-14-4">{{ 'Apply to all facilities'|i18n }}.</span>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #selectDate let-data let-close="close">
    <div class="tip-dialog app-dialog-background">
        <app-ec-select-date [summaryConsolidations]="summaryResponse"
                            [dateSelection]="DATE_SELECTION.YEAR"
                            [content]="CONTENT_DIALOG.YEARLY"
                            [minDate]="getMomentFromMs(getYear(billingPeriodCfg.pastDate), timeZone)"
                            [maxDate]="getPastMonth(timeZone)"
                            (values)="data.values = $event"
                            (valid)="data.valid = $event">
        </app-ec-select-date>
    </div>
    <div fxLayout="row" fxLayoutAlign="center" class="mt-24" fxLayoutGap="20px">
        <button app-ghost-button [mat-dialog-close]="false">
            {{ 'Not now'|i18n }}
        </button>
        <button app-primary-button [disabled]="!data.valid || !data.values"
                (click)="close(data.values)">
            {{ 'Configure'|i18n }}
            <app-icon class="ml-10" name="fal-arrow-right"></app-icon>
        </button>
    </div>
</ng-template>

<ng-template #adviceDialog let-data="data" let-close="close">
    <div class="advice-main-dialog">
        <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="25px">

            <!-- cacv plants -->
            <div *ngIf="data.mode === DialogMode.CACV_PLANTS">
                <div class="txt-p-16-4"
                     [innerHTML]="'With this action, the entire amount generated by the {0} of a plant will go to the plant itself.'|i18n: CACV_STRING">
                </div>
                <div class="txt-p-16-4">{{ 'This applies only to plants of members or third-party producers.'|i18n }}</div>
                <div class="txt-p-16-4 mt-25">{{ 'You will still be able change this parameter later.'|i18n }}</div>
            </div>

            <!-- cacv redistribution -->
            <div *ngIf="data.mode === DialogMode.CACV_REDISTRIBUTION">
                <div class="txt-p-16-4"
                     [innerHTML]="'With this action, the entire amount generated by the {0} of the plants will go to the consumer utilities and not to the plants.'|i18n: CACV_STRING">
                </div>
                <div class="txt-p-16-4 mt-25">{{ 'You will still be able change this parameter later.'|i18n }}</div>
            </div>

            <!-- cacv set aside -->
            <div *ngIf="data.mode === DialogMode.CACV_SET_ASIDE">
                <div class="txt-p-16-4"
                     [innerHTML]="'With this action, the entire amount generated by the {0} will not be redistributed.'|i18n: CACV_STRING">
                </div>
                <div class="txt-p-16-4 mt-25">{{ 'You will still be able change this parameter later.'|i18n }}</div>
            </div>

            <!-- cacv as tip -->
            <div *ngIf="data.mode === DialogMode.CACV_AS_TIP">
                <div class="txt-p-16-4"
                     [innerHTML]="'With this action, the entire amount generated by the {0} of the plants will be allocated to consumer utilities and plants respectively, according to the TIP configuration.'|i18n: CACV_STRING">
                </div>
                <div class="txt-p-16-4 mt-25">{{ 'You will still be able change this parameter later.'|i18n }}</div>
            </div>

            <!-- tip -->
            <div *ngIf="data.mode === DialogMode.TIP">
                <span class="txt-p-16-4">{{ 'This action will enter for each plant the'|i18n }} </span>
                <span class="txt-p-16-7">TIP </span>
                <span class="txt-p-16-4">{{ 'value you have just chosen, overwriting any changes made to the fields of a specific plant.'|i18n }}</span>
            </div>

            <!-- rei -->
            <div *ngIf="data.mode === DialogMode.REI">
                <span class="txt-p-16-4">{{ 'This action will allocate the'|i18n }} </span>
                <span class="txt-p-16-7">{{ 'injected energy withdrawal'|i18n }} </span>
                <span class="txt-p-16-4">{{ 'of all community-owned facilities to the per-member withdrawal allocation, overriding any changes made on the fields of a specific facility.'|i18n }}</span>
            </div>

            <div *ngIf="data.mode !== DialogMode.CACV_REDISTRIBUTION && data.mode !== DialogMode.CACV_PLANTS && data.mode !== DialogMode.CACV_SET_ASIDE && data.mode !== DialogMode.CACV_AS_TIP"
                 class="txt-p-16-4">
                {{ 'You will still be able to make changes on an individual plant later.'|i18n }}
            </div>
        </div>

    </div>
    <div fxLayout="column" fxLayoutAlign="center center" class="mt-24">
        <div fxLayout="row" fxLayoutAlign="center start" fxLayoutGap="48px">
            <button app-ghost-button (click)="close(false)">{{ 'Cancel'|i18n }}</button>
            <button app-primary-button (click)="close(true)">{{ 'Confirm'|i18n }}</button>
        </div>
    </div>
</ng-template>
